<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep2ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 금리 안내(정기적금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">USD</th>
          <th scope="col">KHR</th>
          <th>{{ /*금리구분*/ $t("MDEP-01-02-02-08") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-html="/*6개월 이상~12개월 미만*/ $t('MDEP-01-02-02-17')"></td>
          <td>3.05</td>
          <td rowspan="4">N/A</td>
          <td>{{ /*확정금리*/ $t("MDEP-01-02-02-09") }}</td>
        </tr>
        <tr>
          <td v-html="/*1년 이상~2년 미만*/ $t('MDEP-01-02-02-18')"></td>
          <td>3.50</td>
          <td>{{ /*확정금리*/ $t("MDEP-01-02-02-09") }}</td>
        </tr>
        <tr>
          <td v-html="/*2년 이상~3년 미만*/ $t('MDEP-01-02-02-19')"></td>
          <td>3.70</td>
          <td>{{ /*확정금리*/ $t("MDEP-01-02-02-09") }}</td>
        </tr>
        <tr>
          <td v-html="/*3년 이상*/ $t('MDEP-01-02-02-20')"></td>
          <td>3.85</td>
          <td>{{ /*확정금리*/ $t("MDEP-01-02-02-09") }}</td>
        </tr>
      </tbody>
    </table>
    <div class="info info-etc">· {{ /*영업점 내점상담 후, 금리 결정*/ $t("MDEP-01-02-02-21") }}</div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      currentTab: 1,
    };
  },
};
</script>